export const InputStyle = {
  // style object for base or default style
  baseStyle: {
    fontWeight: '400',
  },
  variants: {
    noOutlineInput: {
      field: {
        borderRadius: 0,
        border: 'none',
        _autofill: {
          boxShadow: '0 0 0px 1000px white inset',
        },
        _focus: {
          //   borderColor: 'none',
          boxShadow: '0 0 0px 1000px white inset',
        },
      },
    },
  },
  // default values for 'size', 'variant' and 'colorScheme'
  defaultProps: {},
}
